import React from "react";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import BusinessUnitAssignContent from "./components/businessUnitAssignContent";
import BusinessUnitAssignList from "./components/businessUnitAssignList";

export default function BusinessUnitAssign() {
  return (
    <div>
      <StepperContentHolder>
        <BusinessUnitAssignList />
      </StepperContentHolder>
    </div>
  );
}
